import axios from "axios";

/*
 * ---------------------------------------------------------------------
 * import Action types
 * ---------------------------------------------------------------------
 */
import {
    OPEN_PLAZZ_CHAT,
    CLOSE_PLAZZ_CHAT,
    SET_PLAZZ_CHAT_CONVERSATIONS,
    SET_PLAZZ_CHAT_PERSONS,
    SET_PLAZZ_CHAT_NEWMESSAGE,
    UPDATE_PLAZZ_CHAT_CONVERSATION,
    SET_PLAZZ_CHAT_UNREAD_COUNT,
    SET_PLAZZ_CHAT_PERSON_ANCHOR,
    UPDATE_PLAZZ_CHAT_CONVERSATION_PARTNER,
    DISPOSE_PLAZZ_CHAT,
    SET_PLAZZ_CHAT_PERSON_FILTER,
} from "./types";

import {
    setError
} from "src/shared_modules/veu-visitors-core/actions/system";

import { getConfig } from "src/config/axios";
/*
 * ---------------------------------------------------------------------
 * Public Actions
 * ---------------------------------------------------------------------
 */
export const setChatConversations = ( arr ) => ({
    type: SET_PLAZZ_CHAT_CONVERSATIONS,
    payload: arr
});

export const setChatPersons = ( arr ) => ({
    type: SET_PLAZZ_CHAT_PERSONS,
    payload: arr
});

export const setChatNewMessage = ( val, count=0 ) => ({
    type: SET_PLAZZ_CHAT_NEWMESSAGE,
    payload: {
        hasNewMessage : val,
        messageCount : count
    }
});

export const setChatUnreadCount = ( val ) => ({
    type: SET_PLAZZ_CHAT_UNREAD_COUNT,
    payload: val
});

export const setChatPersonAnchor = ( val ) => ({
    type: SET_PLAZZ_CHAT_PERSON_ANCHOR,
    payload: val
});

export const updateChatConversation = ( partnerid, messages ) => ({
    type: UPDATE_PLAZZ_CHAT_CONVERSATION,
    payload: {
        partnerid: partnerid,
        messages: messages
    }
});

export const updateChatPartner = ( person ) => ({
    type: UPDATE_PLAZZ_CHAT_CONVERSATION_PARTNER,
    payload: person
});

export const disposeChat = () => ({
    type: DISPOSE_PLAZZ_CHAT,
    payload: null
});

export const setChatPersonFilter = ( filter ) => ({
    type: SET_PLAZZ_CHAT_PERSON_FILTER,
    payload: filter
});


// tab can be persons or conversations
// activeConvOrPerson is optional to start with open profile or confersiation view
export const openChat = ( tab, activeConvOrPerson=null ) => ({
    type: OPEN_PLAZZ_CHAT,
    payload: { tab: tab, active: activeConvOrPerson }
});

export const closeChat = ( ) => ({
    type: CLOSE_PLAZZ_CHAT,
    payload: null
});
/*
 * ---------------------------------------------------------------------
 * async thunks
 * ---------------------------------------------------------------------
 */
export const fetchChatPersonList = ( lookup="event" ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/person/list/"+lookup;
        let headers = axiosconf.headers;

        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                dispatch( setChatPersons(response.data))
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const fetchChatConversationList = () => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/chat/list";
        let headers = axiosconf.headers;
        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                // look for unread messages
                let item = null;
                let unread = 0;
                let hasNew = false;
                // count all
                for( let i=0; i<response.data.length; i++ ) {
                    item = response.data[i];
                    unread = unread + parseInt(item.unread_count);
                }

                if( unread > 0 )
                    hasNew = true;

                dispatch( setChatNewMessage(hasNew, unread) );
                // update conversations
                dispatch( setChatConversations(response.data) );
            } else if( response.status === 304 ) {
                console.warn("nothing changed");
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const fetchChatMessages = ( personid ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/chat/messages/"+personid;
        let headers = axiosconf.headers;
        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                dispatch( updateChatConversation( personid, response.data ) );
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const sendChatMessage = ( personid, message ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/chat/send/"+personid;
        let data = { text : message };
        let headers = axiosconf.headers;
        dispatch( setError(null) );

        const done = await axios.post(url, data, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                console.log("sendChatMessages success");
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const fetchPerson = ( personid ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/person/info/"+personid;
        let headers = axiosconf.headers;
        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                dispatch( updateChatPartner(response.data))
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const syncConversation = ( personid ) => {
    return async ( dispatch, getState ) => {
        let axiosconf = getConfig().veu;

        let url = "/visitors/plazz/chat/sync/" + personid;
        let headers = axiosconf.headers;
        dispatch( setError(null) );

        const done = await axios.post(url, null , {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            if( response.status === 200 ) {
                console.log("syncConversation success");
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}
